import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    gridArea: 'topbar',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.custom.background.area,
    minHeight: theme.spacing(8),
    borderBottom: `solid 1px ${theme.palette.divider}`,
    overflow: 'hidden',

    '& .text-title': {
      color: theme.palette.text.primary,
      '&-container': {
        flexGrow: 1,
        overflow: 'hidden',
      },
    },

    '& .steps': {
      height: '100%',
    },

    '& .btn-schedule': {
      padding: `0 ${theme.spacing(3)}px`,
      border: `solid 1px ${theme.palette.divider}`,
      borderWidth: '0 0 0 1px',
      color: theme.palette.text.hint,

      '&-icon, &-text': {
        color: theme.palette.custom.feedback.positive,
      },
      '&-icon': {
        marginRight: theme.spacing(1),
      },
      '&-text': {
        fontWeight: theme.typography.fontWeightMedium,
        lineHeight: 1.2,
      },
    },

    [theme.breakpoints.up('md')]: {
      '& .btn-icon-right-wrapper': {
        margin: `0 ${theme.spacing(2)}px`,
      },

      '& .btn-schedule': {
        height: '100%',
      },
    },

    [theme.breakpoints.down('sm')]: {
      [`& .btn-icon-right-wrapper,
        & .btn-toggle-sidemenu`]: {
        margin: `0 ${theme.spacing(2)}px`,
      },

      '& .btn-toggle-sidemenu': {
        order: 6,
      },

      '& .btn-schedule': {
        order: 5,
        height: '100%',
        borderWidth: '0 1px',
      },
    },

    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
      minHeight: theme.spacing(6),

      '&.with-steps': {
        minHeight: theme.spacing(14),
      },

      '& .text-title': {
        ...theme.typography.caption,
        '&-container': {
          width: `calc(100% - (${theme.spacing(9)}px * 2))`,
          height: theme.spacing(6),
          display: 'flex',
          alignItems: 'center',
        },
      },

      '& .btn-schedule': {
        order: 5,
        width: '100%',
        height: theme.spacing(6),
        borderWidth: '1px 0 0',
        position: 'fixed',
        zIndex: 2,
        bottom: 0,
        backgroundColor: theme.palette.custom.background.area,
      },

      '& .steps': {
        order: 7,
        height: 'auto',
        width: '100%',
        justifyContent: 'space-around',
        borderTop: `solid 1px ${theme.palette.divider}`,
        padding: theme.spacing(1, 0),
      },
    },
  },
}));

export default styles;
